import React, { useState, useEffect } from 'react';
import CargomaticModal from 'components/v2/modal';
import CargomaticSelect from 'components/v2/select';
import AccessorialRatesModalCustomerRows from 'components/modules/pricing/AccessorialRatesModalCustomerRows';
import ErrorLabel from 'components/v2/forms/ErrorLabel';
import AddButton from 'components/v2/buttons/AddButton';
import { useTranslation } from 'react-i18next';
import Label from 'components/v2/forms/Label';
import LoadingCircle from 'components/ui/LoadingCircle';
import { startCase } from 'lodash';
export default function AddAccessorialCustomersMarketModal({ showModal, onClose, customerData, onAddCustomer, onChangeCustomer, marketsArray, onMarketChange, market, onZoneBlur, searchCustomerType, onRemoveCustomerRow, setShowAddAccessorialsModal, disableButtons, missingRequiredFields, areCustomersNaiveToMarket, areCustomersTheSameType, isCustomerTypeValid, isFetchingExistingCustomers, duplicateCustomers, }) {
    const [saveDisabled, setSaveDisabled] = useState(false);
    const { t } = useTranslation();
    const LOADING_TEXT = t('LOADING');
    useEffect(() => {
        setSaveDisabled(disableButtons);
    }, [disableButtons]);
    const REQUIRED_FIELDS_MISSING_ERROR = t('REQUIRED_FIELDS_MISSING_ERROR');
    const INVALID_CUSTOMER_TYPE_SELECTED_ERROR = t('INVALID_CUSTOMER_TYPE_SELECTED_ERROR');
    const CUSTOMERS_HAVE_EXISTING_ACCESSORIAL_RATES_ERROR = t('CUSTOMERS_HAVE_EXISTING_ACCESSORIAL_RATES_ERROR');
    const MORE_THAN_ONE_CUSTOMER_TYPE_SELECTED_ERROR = t('MORE_THAN_ONE_CUSTOMER_TYPE_SELECTED_ERROR');
    const DUPLICATE_CUSTOMER_ERROR = t('DUPLICATE_CUSTOMER_ERROR');
    const getTitle = () => {
        return (React.createElement("div", { "data-testid": "div-d33312bc" },
            React.createElement("div", { "data-testid": "div-e7a91b31", className: "absolute w-4/6 left-3 top-3" }, t('STEP_1_ENTER_CUSTOMER_AND_MARKET')),
            React.createElement(AddButton, { dataTestId: "AddButton-abe0c990", className: "absolute right-10 top-1", disabled: !market, onClick: () => onAddCustomer() })));
    };
    const renderMarket = () => {
        return (React.createElement("div", { "data-testid": "div-48aa2166", className: "w-3/4 ml-4" },
            React.createElement(CargomaticSelect, { dataTestId: "CargomaticSelect-60e9a1ce", items: marketsArray, onSelect: (market) => {
                    onMarketChange(market);
                }, value: market, textKey: "name", valueKey: "slug", hideLabel: true })));
    };
    const renderErrorDuplicateCustomers = () => {
        if (!duplicateCustomers) {
            return null;
        }
        return (React.createElement("div", { "data-testid": "div-9ae190b2", className: "m-5" },
            React.createElement(ErrorLabel, { dataTestId: "ErrorLabel-ba7573b6" }, DUPLICATE_CUSTOMER_ERROR)));
    };
    const renderErrorMissingRequiredFields = () => {
        if (!missingRequiredFields) {
            return null;
        }
        return (React.createElement("div", { "data-testid": "div-82970bdc", className: "m-5" },
            React.createElement(ErrorLabel, { dataTestId: "ErrorLabel-4914e15d" }, REQUIRED_FIELDS_MISSING_ERROR)));
    };
    const renderErrorInvalidCustomerSelected = () => {
        if (isCustomerTypeValid) {
            return null;
        }
        return (React.createElement("div", { "data-testid": "div-b9366980", className: "m-5" },
            React.createElement(ErrorLabel, { dataTestId: "ErrorLabel-dfb65399" }, INVALID_CUSTOMER_TYPE_SELECTED_ERROR)));
    };
    const renderErrorAreCustomersSameType = () => {
        if (areCustomersTheSameType) {
            return null;
        }
        return (React.createElement("div", { "data-testid": "div-3b6da9d6", className: "m-5" },
            React.createElement(ErrorLabel, { dataTestId: "ErrorLabel-93bbbc68" }, MORE_THAN_ONE_CUSTOMER_TYPE_SELECTED_ERROR)));
    };
    const renderErrorAreCustomersNaiveToMarket = () => {
        if (areCustomersNaiveToMarket) {
            return null;
        }
        return (React.createElement("div", { "data-testid": "div-e405d1e6", className: "m-5" },
            React.createElement(ErrorLabel, { dataTestId: "ErrorLabel-995e7f75" }, CUSTOMERS_HAVE_EXISTING_ACCESSORIAL_RATES_ERROR)));
    };
    const renderErrors = () => {
        return (React.createElement(React.Fragment, null,
            renderErrorMissingRequiredFields(),
            renderErrorInvalidCustomerSelected(),
            renderErrorAreCustomersSameType(),
            renderErrorAreCustomersNaiveToMarket(),
            renderErrorDuplicateCustomers()));
    };
    const getBody = (customerData, isLoading) => {
        return (React.createElement(React.Fragment, null,
            isLoading && (React.createElement("div", { "data-testid": "div-d998fb39", className: "mb-4" },
                React.createElement(LoadingCircle, { dataTestId: "LoadingCircle-16094e15", text: LOADING_TEXT }))),
            React.createElement("div", { "data-testid": "div-0ac04b6d", className: "mb-4" },
                React.createElement(Label, { dataTestId: "Label-7271bb48" }, startCase(t('MARKET', { count: 1 }))),
                renderMarket(market)),
            React.createElement("h3", { "data-testid": "h3-78eb7053", className: "mb-4" }, startCase(`${t('USER', { count: 2 })}`)),
            React.createElement("table", { "data-testid": "table-e7069faf", className: "default-table" },
                React.createElement("thead", { "data-testid": "thead-915debd8" },
                    React.createElement("tr", { "data-testid": "tr-263d9170" },
                        React.createElement("th", { "data-testid": "th-418592c3" }, startCase(`${t('USER', { count: 2 })}`)),
                        React.createElement("th", { "data-testid": "th-16aab2be" }))),
                React.createElement("tbody", { "data-testid": "tbody-2d862197" },
                    customerData.map((item, i) => {
                        return (React.createElement(AccessorialRatesModalCustomerRows, { index: i, key: i, item: item, marketsList: marketsArray, onZoneBlur: (item) => onZoneBlur(item, i), handleCustomerField: onChangeCustomer(i), searchCustomerType: searchCustomerType, missingRequiredFields: missingRequiredFields, onRemoveCustomerRow: onRemoveCustomerRow(i) }));
                    }),
                    React.createElement("tr", { "data-testid": "tr-7fb52586" })))));
    };
    const getFooter = () => {
        return (React.createElement("div", { "data-testid": "div-7bb668a5", className: "flex flex-row-reverse" },
            React.createElement("div", { "data-testid": "div-593dbb76", className: "mt-3" },
                React.createElement("div", { "data-testid": "div-1540856c", className: "flex justify-end button-group" },
                    React.createElement("button", { "data-testid": "button-4ab92ad1", className: "button button-secondary", onClick: () => onClose(true) }, startCase(`${t('CANCEL')}`)),
                    React.createElement("button", { "data-testid": "button-0d7901c2", disabled: saveDisabled || isFetchingExistingCustomers, className: "button button-green", onClick: () => handleAddRates() }, startCase(`${t('NEXT')}`)))),
            renderErrors()));
    };
    const handleAddRates = () => {
        onClose();
        setShowAddAccessorialsModal(true);
    };
    return (React.createElement(CargomaticModal, { dataTestId: "CargomaticModal-3bc152e6", title: getTitle(), show: showModal, style: { top: '15%' }, onHide: () => onClose(true), body: getBody(customerData, isFetchingExistingCustomers), footer: getFooter(), dialogClassName: "rounded-xl border-4 border-green-cm w-min", size: "lg" }));
}
